export default __webpack_public_path__ + "static/media/screenshot2.ba549a3e.png";